import React from "react";
import { useSelector } from "react-redux";
import { Route, useHistory } from "react-router-dom";
import LoadingComponent from "./LoadingComponent";
import { ACCOUNT_SIGN_IN_ROUTE, HOME_PAGE_ROUTE } from "../api/routeConstants";

export const EMPLOYER_ROLE = "employer";
export const ADMIN_ROLE = "admin";
export const JOB_SEEKER_ROLE = "jobSeeker";
const SUPERVISOR_ROLE = "supervisor";

export default function PrivateRoute({ component: Component, ...rest }) {
  const history = useHistory();

  const { authenticated } = useSelector((state) => state.auth);
  const { currentUserAccount } = useSelector((state) => state.account);

  if (authenticated && !currentUserAccount) {
    return <LoadingComponent initialLoading={true} />;
  }

  function isRoleAuthorised(role) {
    if (role === EMPLOYER_ROLE) {
      return currentUserAccount?.isEmployer;
    } else if (role === ADMIN_ROLE) {
      return currentUserAccount?.isAdmin;
    } else if (role === SUPERVISOR_ROLE) {
      return currentUserAccount?.isAdmin || currentUserAccount?.isEmployer;
    } else if (role === JOB_SEEKER_ROLE) {
      return currentUserAccount?.isJobSeeker;
    }
  }

  function redirectUnauthorised(role) {
    if (role) {
      history.push(ACCOUNT_SIGN_IN_ROUTE);
    } else {
      history.push(HOME_PAGE_ROUTE);
    }
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated && isRoleAuthorised(rest.role) ? (
          <Component {...props} />
        ) : (
          redirectUnauthorised(rest.role)
        )
      }
    />
  );
}
